//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            keyword: '',
            focus: false
        }
    },
    methods: {
        onFocus () {
            this.focus = true
        },
        onBlur () {
            this.focus = false
        },
        onSearch () {
            this.$emit('onSearch', this.keyword)
        },
        clearInput () {
            this.keyword = ''
        }
    }
}
